import { render, staticRenderFns } from "./UserSelectPopup2.vue?vue&type=template&id=b0774642&scoped=true&lang=pug&"
import script from "./UserSelectPopup2.vue?vue&type=script&lang=js&"
export * from "./UserSelectPopup2.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectPopup2.vue?vue&type=style&index=0&id=b0774642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0774642",
  null
  
)

export default component.exports